import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { GiPartyPopper } from "react-icons/gi";
import { jwtDecode } from "jwt-decode";

const PaymentSuccessPage = () => {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const userId = decoded.id || decoded._id;
  const navigate = useNavigate();
  const location = useLocation();

  // Payment info passed from previous page
  const { amount } = location.state || { amount: 0 };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen  p-4">
      <div className="bg-white p-6 rounded-2xl shadow-lg w-full max-w-md text-center">
        <GiPartyPopper className="text-6xl text-green-500 mx-auto mb-4" />
        <h2 className="text-3xl font-bold text-green-700 mb-2">Congratulations!</h2>
        <p className="text-gray-700 mb-4">
          Your payment of <span className="font-semibold">₦{amount.toLocaleString()}</span> has been processed.
        </p>
        <p className="text-gray-500 mb-6">You can now use this balance to fund your purchases or services.</p>

        <button
          onClick={() => navigate(`/balancepage/${userId}`)}
          className="bg-green-500 text-white px-6 py-3 rounded-xl hover:bg-green-600 w-full"
        >
          Go to My Balance
        </button>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
